import AuthScreen from './AuthScreen';
export default function Register() { return <AuthScreen register />; }
